import setSpecies$1 from '../internals/set-species.js';

var setSpecies = setSpecies$1; // `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species

setSpecies('Array');
